import { render, staticRenderFns } from "./priceIncreasingTooFast.vue?vue&type=template&id=c491d804"
import script from "./priceIncreasingTooFast.vue?vue&type=script&lang=js"
export * from "./priceIncreasingTooFast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports